<template>
  <div style="margin-top: 0 !important" v-show="show">
    <div class="my-outbox" id="headerNotice">
      <div class="box">
        <img src="../../../static/noticeBox.png" alt="" srcset="" />
        <div class="wrap">
          <div class="my-inbox" ref="box">
            <div
              class="my-list"
              v-for="(item, index) in sendVal"
              :key="index"
              ref="list"
              v-html="item.detail"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 通知公告弹窗 -->
    <div class="pop_dilog" v-show="visible"></div>
      <div class="pop_main" v-show="visible">
        <img class="pop_main_ticon" src="../../../static/laba.png" alt="" srcset="" />
        <h3>通知公告</h3>
        <p class="noticeContent" v-html="noticeData.noticeContent"></p>
        <button @click="close">我知道了</button>
      </div>
  </div>
</template>
  
  <script>
import { homeNotice } from "@/apiCloud/noticeBox";
export default {
  name: "my-marquee-left",
  data() {
    return {
      // 定时器标识
      nowTime: null,
      // 每一个内容的宽度
      disArr: [],
      noticeData: "",
      sendVal: [
        {
          detail: "",
        },
      ],
      visible: false,
      path: "",
      show: false,
    };
  },
  created() {
    this.fullPath = this.$route.path;
    this.getHomeNotice();
  },
  mounted() {
    // var that = this

    setTimeout(() => {
      var item = this.$refs.list;
      var outbox = this.$refs.box;

      var len = this.sendVal.length;
      var arr = [];
      // 因为设置的margin值一样，所以取第一个就行。
      var margin = this.getMargin(item[0]);
      for (var i = 0; i < len; i++) {
        arr.push(item[i].clientWidth + margin); // 把宽度和 margin 加起来就是每一个元素需要移动的距离
      }
      this.disArr = arr;

      if (item[0].clientWidth > outbox.clientWidth) {
        this.moveLeft();
      }
    }, 1000);
  },
  beforeDestroy() {
    // 页面关闭清除定时器
    clearInterval(this.nowTime);
    // 清除定时器标识
    this.nowTime = null;
  },
  methods: {
    // 获取margin属性
    getMargin(obj) {
      var marg = window.getComputedStyle(obj, null)["margin-right"];
      marg = marg.replace("px", "");
      return Number(marg); // 强制转化成数字
    },
    // 移动的方法
    moveLeft() {
      var that = this;
      var outbox = this.$refs.box;
      // 初始位置
      var startDis = 0;
      //   console.log('that.disArr: ', that.disArr)
      this.nowTime = setInterval(function () {
        startDis -= 0.5;
        // console.log('初始化移动：', startDis)
        if (Math.abs(startDis) > Math.abs(that.disArr[0])) {
          // 每次移动完一个元素的距离，就把这个元素的宽度
          that.disArr.push(that.disArr.shift());
          // 每次移动完一个元素的距离，就把列表数据的第一项放到最后一项
          // console.log('that.sendVal: ', that.sendVal)
          // console.log('that.sendVal: ', that.sendVal.shift())
          that.sendVal.push(that.sendVal.shift());
          startDis = 0;
          // console.log('移动')
        } else {
          // console.log('不来不来就不来...')
        }
        // 每次都让盒子移动指定的距离，在我自己做的项目中，这种字符串拼接的方法并没有生效
        // outbox.style = 'transform: translateX3d(' + startDis + 'px)'
        // 后面换了es6的模板字符串就可以了
        outbox.style = `transform: translateX(${startDis}px)`;
        // outbox.style = 'transform: translateX(\' + startDis + \' px)'
        // outbox.style.marginLeft = 'startDis'
        // console.log('这里:', startDis)
      }, 1000 / 60);
    },

    getHomeNotice() {
      homeNotice().then((res) => {
        if (res.data) {
          this.show = true;
          this.noticeData = res.data;
          this.sendVal[0].detail = res.data.noticeContent;
          let noticeData = JSON.parse(localStorage.getItem("noticeData"));
          if (!noticeData) {
            localStorage.setItem("noticeData", JSON.stringify(res.data));
            if (this.fullPath == "/home") {
               this.visible = true;
            }
          } else if (noticeData.noticeId != res.data.noticeId) {
            localStorage.setItem("noticeData", JSON.stringify(res.data));
            if (this.fullPath == "/home") {
               this.visible = true;
            }
          }
        } else {
          this.show = false;
        }
      });
    },
    // 弹窗关闭
    close() {
      this.visible = false;
    },
  },
};
</script>
  
  <style lang="less" scoped>
.my-outbox {
  overflow: hidden;
  width: 100%;
  height: 32px;
  background: #ffefef;
  margin-top: 0 !important;
  &.fixed {
    position: fixed;
    top: 60px;
    left: 0;
    z-index: 999;
  }
  .box {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    overflow: hidden;
    display: flex;
    align-items: center;
    img {
      display: block;
      width: 16px;
      height: 16px;
      margin-right: 5px;
    }
  }
  .wrap {
    flex: 1;
    overflow: hidden;
  }
  .my-inbox {
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
    white-space: nowrap;
    font-size: 16px;
    font-weight: 400;
    color: #fd3030;
    .my-list {
      margin-right: 100px;
      display: inline-block;
      text-indent: 5px;
      /deep/ img{
        display:none;
      }
    }
  }
}
.pop_dilog {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  background: #000;
  z-index: 99;
}
.pop_main {
  position: fixed;
  left: 50%;
  top: 50%;
  margin-left: -260px;
  transform: translateY(-50%);
  z-index: 1000;
  width: 520px;
  // min-height: 292px;
  background: #ffffff;
  border-radius: 6px;
  box-sizing: border-box;
  padding-bottom: 40px;
  img.pop_main_ticon {
    display: block;
    width: 92px;
    height: 81px;
    margin: -30px auto 0;
  }
  /deep/ img{
    max-width: 90%;
    display: block;
    width: auto;
    height: auto;
    margin: 0 auto;
  }
  h3 {
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    text-align: center;
    margin-top: 24px;
  }
  p {
    box-sizing: border-box;
    padding: 0 20px;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    width: 90%;
    margin: 24px auto 0;
    max-height: 400px;
    overflow-y: auto;
  }
  button {
    cursor: pointer;
    display: block;
    width: 170px;
    height: 32px;
    background: #3686ff;
    border-radius: 16px;
    text-align: center;
    line-height: 32px;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
    margin: 30px auto 0;
  }
}
/* 整个滚动条 */
::-webkit-scrollbar {
    /* 对应纵向滚动条的宽度 */
    width: 6px;
    /* 对应横向滚动条的宽度 */
    height: 6px;
}

/* 滚动条上的滚动滑块 */
::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 32px;
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
    background-color: #f1f1f1;
    border-radius: 32px;
}

</style>


// WEBPACK FOOTER //
// src/components/noticeBox/noticeBox.vue